<template>
	<div class="FZLC">
		<div class="content fz">
			<div class="content_2 c3 lh7">
				<div class="f30">发展历程</div>
				<div class="f20 mb45">DEVELOPMENT COURSE</div>
				<div v-if="$store.state.mobile">
					<!-- 移动端 -->
					<el-timeline>
						<template v-for="(item, i) in FZLC">
							<transition v-show="item.show" name="el-zoom-in-center">
								<el-timeline-item :timestamp="item.year" placement="top">
									<el-card class="">
										<span v-html="item.html" class="vf4"></span>
										<img :src="item.src" class="w100 mt10" />
									</el-card>
								</el-timeline-item>
							</transition>
						</template>
					</el-timeline>
				</div>
				<div v-else>
					<!-- 电脑端 -->
					<div class="pb50"></div>
					<template v-for="(item, i) in FZLC">
						<transition v-show="item.show" name="el-zoom-in-center">
							<div class="pb50" style="transition: all 1s;-webkit-transition: all 1s;">
								<el-row justify="space-between" type="flex">
									<el-col :span="10">
										<div class="info h100">
											<div class="tr w100">
												<div v-if="i%2 != 0" class="tr">
													<span v-html="item.html"></span>
												</div>
												<div v-else class="tr w100">
													<img :src="item.src" />
												</div>
											</div>
										</div>
									</el-col>
									<el-col :span="4">
										<div class="tz year zzz h100 pr"><span>{{item.year}}</span></div>
									</el-col>
									<el-col :span="10">
										<div class="info h100">
											<div v-if="i%2 == 0" class="info h100">
												<span v-html="item.html"></span>
											</div>
											<img v-else :src="item.src" />
										</div>
									</el-col>
								</el-row>
							</div>
						</transition>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				FZLC: [{
						year: '2021',
						html: `1月，拓展潍坊集团潍坊柴油发动机有限公司厂内供应链服务业务。`,
						src: require('@/assets/FZLC_1.jpg')
					},
					{
						year: '2020',
						// 新舟科技的WMS产品
						html: `10月，拓展天际汽车长沙工厂厂内供应链服务业务，正式进军新能源汽车供应链业务，WMS产品也成功在新能源汽车领域中应用。<br/>10月，拓展长城汽车河北保定工厂厂内供应链服务业务。<br/>9月，公司获得国家级高新技术企业、省级小巨人等科技资质。<br/>8月，全资子公司杭州裕新科技生产的AGV无人叉车正式亮相青岛解放，并作为主力产品受邀参加青岛解放全国发布会，收到国内各主机厂一致好评。<br/>5月，成立一汽红旗蔚山工厂仓储中心及蔚山工厂配送中心，库房总面积达到12万平。`,
						src: require('@/assets/FZLC_2.jpg')
					},
					{
						year: '2019',
						html: `7月，公司再一次布局全国市场，拓展了一汽解放无锡柴油机厂的厂内供应链服务业务。<br/>3月，自主研发的WMS系统正式在大众物流仓储基地上线，拥有完全自主知识产权，产品功能达到国内一流水平。`,
						src: require('@/assets/FZLC_3.jpg')
					},
					{
						year: '2018',
						// html: `公司注资5000万，分别在长春高新区和杭州滨江区成立吉林省新舟智能科技有限公司和杭州裕新智能科技有限公司。`,
						html: `公司注资5000万，在杭州滨江区成立杭州裕新智能科技有限公司。`,
						src: require('@/assets/FZLC_4.jpg')
					},
					{
						year: '2017',
						html: `开展一汽解放青岛汽车有限公司产前物流服务业务及中国中车生产线外包业务。`,
						src: require('@/assets/FZLC_5.jpg')
					},
					{
						year: '2016',
						html: `开展中国中车轨道客车、东风裕隆内物流服务业务。`,
						src: require('@/assets/FZLC_6.jpg')
					},
					{
						year: '2015',
						html: `依托现有项目，开展一汽客车内物流服务业务，开拓短途及干线运输业务。`,
						src: require('@/assets/FZLC_7.jpg')
					},
					{
						year: '2013',
						html: `公司在巩固汽车产前、产中物流服务的竞争优势的基础上，开始承接生产线外包业务。`,
						src: require('@/assets/FZLC_8.jpg')
					},
					{
						year: '2009',
						html: `公司开始延伸物流服务范围，承接了一汽轿车的产中物流服务业务。`,
						src: require('@/assets/FZLC_9.jpg')
					},
					{
						year: '2005',
						html: `公司开拓新的汽车零部件物流领域服务项目，承接一汽轿车零部件的产前仓储物流业务。`,
						src: require('@/assets/FZLC_10.jpg')
					},
					{
						year: '2004',
						html: `公司开始拓展业务范围，承接青岛海尔集团吉林省内的全品种仓储业务。`,
						src: require('@/assets/FZLC_11.jpg')
					},
					{
						year: '2001',
						html: `公司成立，承接一汽-大众车轮总成装配及模块装配业务。`,
						src: require('@/assets/FZLC_12.jpg')
					}
				]
			}
		},
		created() {
			this.FZLC.forEach(x => x.show = false);
		},
		mounted() {
			let i = 0;
			this.FZLC[i].show = true;
			let interval = setInterval(() => {
				i++;
				this.FZLC[i].show = true;
				if (i >= this.FZLC.length - 1) {
					clearInterval(interval)
				}
			}, 200)
		},
		methods: {

		}
	}
</script>

<style lang="scss">
	@import '@/assets/css/theme.scss';

	.FZLC {
		padding-bottom: 65px;
		
		.el-timeline {
			padding-left: 2vw;
		}

		.info {
			display: flex;
			align-items: center;
		}

		.fz {
			padding-top: 65px;
			font-size: 18px;
			color: #404040;

			@media screen and (max-width: 768px) {
				.f30 {
					font-size: 7vw;
					line-height: 1.2;
					text-align: center;
					margin-bottom: 20px;
				}

				.f20 {
					font-size: 16px;
					text-align: center;
					line-height: 1.2;
					margin-bottom: 30px;
				}

				.f18 {
					font-size: 16px;
				}

				padding-left: 2vw;
				padding-right: 4vw;
				box-sizing: border-box;
			}
		}

		.year {
			position: relative;

			span {
				background-color: $blue;
				border-radius: 30px;
				line-height: 30px;
				padding: 0 15px;
				color: #fff;
				z-index: 10;
			}

			&::after {
				content: ' ';
				position: absolute;
				left: 50%;
				right: 50%;
				top: -50px;
				bottom: -50px;
				width: 2px;
				background-color: #d1d1d1;
			}
		}
	}
</style>
